export default {
  toggleLoadingInvoices(state, loading = false) {
    state.loadingInvoices = loading;
  },
  toggleLoadingInvoice(state, loading = false) {
    state.loadingInvoice = loading;
  },
  setLoadingInvoiceForm(state, loadingInvoiceForm = false) {
    state.loadingInvoiceForm = loadingInvoiceForm;
  },
  toggleLoadingInvoiceHistory(state, loading = false) {
    state.loadingInvoiceHistory = loading;
  },
  toggleLoadingInvoiceOrderItems(state, loading = false) {
    state.loadingInvoiceOrderItems = loading;
  },
  invoices(state, invoices = []) {
    state.invoices = invoices;
  },
  invoice(state, invoice) {
    state.invoice = invoice;
  },
  setInvoiceForm(state, invoiceForm) {
    state.invoiceForm = Object.assign({}, state.invoiceForm, invoiceForm);
  },
  invoiceMarkers(state, invoiceMarkers) {
    state.invoiceMarkers = invoiceMarkers;
  },
  invoiceHistory(state, invoiceHistory) {
    state.invoiceHistory = invoiceHistory;
  },
  invoiceOrderItems(state, invoiceOrderItems) {
    state.invoiceOrderItems = invoiceOrderItems;
  },
  setTotalInvoices(state, totalInvoices) {
    state.totalInvoices = totalInvoices;
  },
  setTotalInvoiceOrderItems(state, totalInvoiceOrderItems) {
    state.totalInvoiceOrderItems = totalInvoiceOrderItems;
  },
  setFilters(state, newFilters) {
    Object.assign(state.filters, newFilters);
  },
  setInvoiceOrderItemsPagination(state, newPagination) {
    Object.assign(state.invoiceOrderItemsPagination, newPagination);
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/store/mutations.js